module.exports = __webpack_public_path__ + "img/56.5be736e8.png";